<template>
  <div>
    <PagesPath :pathTitle1="'درباره ما'" :pathTo1="'about-us'"></PagesPath>
    <section class="p-3 bg-white box-shaddow20   container mt-4 mb-5">
      <h5 class="text-color-444 my-4 font-weight-bold">درباره ی چیلک لند</h5>
      <p v-if="settings" class="line-height2 text-color-666 fontsize14 text-justify">
        {{ settings.site.about_us_site }}
      </p>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import PagesPath from "@/parts/Front/components/PagesPath";
export default {
  name: "AboutUs",
  components: {
    PagesPath,
  },
  data() {
    return {
      options: [
        {
          title: "رنگبندی متفاوت",
        },
        {
          title: "قیمت مناسب",
        },
        {
          title: "کیفیت خوب",
        },
      ],
    };
  },
  mounted() {
    let aboutUsImg = document.querySelectorAll(".about-us-why-img")[0];
    aboutUsImg.style.height = aboutUsImg.offsetWidth * 1.2 + "px";
    window.addEventListener("resize", function() {
      let aboutUsImg = document.querySelectorAll(".about-us-why-img")[0];
      aboutUsImg.style.height = aboutUsImg.offsetWidth * 1.2 + "px";
    });
  },
  computed: {
    // دریافت محتوای درخواست هوم
    settings() {
      return this.$store.getters["front/getSettings"];
    },
    
  },
};
</script>

<style scoped></style>
